const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Flechas en las miniaturas + foto principal entera (sin recorte) */
(function () {
  var css =
    '[id^="GalleryViewer"] .product__media img{object-fit:contain!important;object-position:center center!important}' +
    '[id^="GalleryThumbnails"]{position:relative}' +
    '[id^="GalleryThumbnails"] .slider-button{display:none!important}' +
    '.pg-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:34px;height:34px;border-radius:50%;border:none;padding:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.95);color:#111;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.22)}' +
    '.pg-arrow:hover{background:#fff}.pg-arrow--prev{left:4px}.pg-arrow--next{right:4px}' +
    '@media (max-width:749px){.pg-arrow{width:30px;height:30px}}';
  var svgPrev = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var svgNext = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function go(gallery, thumbsEl, step) {
    var thumbs = Array.prototype.slice.call(thumbsEl.querySelectorAll('[data-target]'));
    if (thumbs.length < 2) return;
    var i = thumbs.findIndex(function (t) {
      var b = t.querySelector('button');
      return b && b.getAttribute('aria-current') === 'true';
    });
    if (i < 0) {
      var active = gallery.querySelector('[id^="GalleryViewer"] .product__media-item.is-active');
      var id = active && active.dataset.mediaId;
      i = Math.max(0, thumbs.findIndex(function (t) { return t.dataset.target === id; }));
    }
    var target = thumbs[(i + step + thumbs.length) % thumbs.length];
    var btn = target.querySelector('button');
    if (btn) btn.click();
    var list = thumbsEl.querySelector('.thumbnail-list');
    if (list) {
      var left = target.offsetLeft - (list.clientWidth - target.offsetWidth) / 2;
      list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  function initGallery(gallery) {
    if (gallery.dataset.pgArrows) return;
    var thumbsEl = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbsEl || thumbsEl.querySelectorAll('[data-target]').length < 2) return;
    gallery.dataset.pgArrows = '1';
    [[-1, 'pg-arrow--prev', svgPrev, 'Anterior'], [1, 'pg-arrow--next', svgNext, 'Siguiente']].forEach(function (cfg) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pg-arrow ' + cfg[1];
      b.setAttribute('aria-label', cfg[3]);
      b.innerHTML = cfg[2];
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(gallery, thumbsEl, cfg[0]); });
      thumbsEl.appendChild(b);
    });
  }

  function init() {
    if (!document.getElementById('pg-arrow-style')) {
      var s = document.createElement('style');
      s.id = 'pg-arrow-style';
      s.textContent = css;
      document.head.appendChild(s);
    }
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
